// extracted by mini-css-extract-plugin
export var table = "_y9-0";